import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useSettings} from '../../../../hooks/use-settings'
import settingsParams from '../../../../settingsParams'
import sc from '../../classes.scss'
import {Spinner} from '../../spinner'
import {TodayButtonProps} from './interfaces'
import s from './today-button.scss'

export const TodayButton = ({onClick, dataHook, isMobile, loading}: TodayButtonProps) => {
  const {t} = useTranslation()
  const {get} = useSettings()
  const todayButtonText = get(settingsParams.todayButtonText)
  return (
    <div className={classNames(s.container, {[s.mobile]: isMobile})}>
      {loading ? <Spinner className={s.loader} diameter={20} calendarButton /> : null}
      <button
        data-hook={dataHook}
        onClick={() => onClick()}
        type="button"
        className={classNames(s.button, sc.ellipsis, {
          [s.mobile]: isMobile,
          [s.loading]: loading,
        })}
      >
        {todayButtonText || t('layout.calendar.monthly.controls.today')}
      </button>
    </div>
  )
}
